import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  container: {
    padding: '0 1rem 1rem 0.75rem'
  },

  message: {
    color: '#7F8487',
    fontSize: theme.size.sm,
    whiteSpace: 'break-spaces',
    padding: '1rem 0'
  },

  name: {},

  avatarName: {
    marginLeft: '1rem',
    fontSize: theme.size.sm
  },

  avatarArea: {
    display: 'flex',
    alignItems: 'center',
    color: '#7F8487',
    fontSize: theme.size.sm,
    marginTop: ({ smallMedia, pres }) => (smallMedia && !pres ? '2rem' : '1rem')
  }
}))

export default useStyles
